import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { TextReveal } from './ui/Reveal';
const FAQS = [{
  question: 'What can you fix or ease as a UI/UX design agency?',
  answer: 'We handle everything from brand identity and product strategy to interface design, design systems and front-end handoff — so you get one partner for the whole journey instead of stitching freelancers together.'
}, {
  question: 'Why is UI/UX design important for your business growth?',
  answer: 'Good design shortens the path between a visitor and a decision. Clearer flows lift conversion, reduce support load and make your product easier to sell.'
}, {
  question: 'No solutions in generating enough leads. How can your design help?',
  answer: 'We audit your funnel first, then redesign the messaging, hierarchy and calls to action around the moments where people currently drop off.'
}, {
  question: 'What separates Yetu Design Lab from other top UI/UX design agencies?',
  answer: 'Speed with consistency. You get first designs in 4-5 days, delivered against a documented system so quality never drifts as the project grows.'
}, {
  question: 'Do you work with hard cases or only 500k+ scale companies?',
  answer: 'Both. We work with early-stage founders shaping a first release and with established teams modernising a mature product.'
}, {
  question: 'How long does the entire design process take?',
  answer: 'A focused brand or product sprint runs 2-4 weeks. Larger platforms are broken into milestones so you see finished work every week.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="relative z-10 w-full bg-[#F2F2F2] px-5 py-20 lg:px-8 lg:py-24" data-id="element-42" data-mp="3jxq95x8hz1kx">
      <div className="mx-auto w-full max-w-shell" data-id="element-43" data-mp="3nya3yu5llt3w">
        <h2 className="text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-44" data-mp="1ugumnwcgebqk">
          <TextReveal data-id="element-45" data-mp="1ppmcuz77oocv">Frequently Asked</TextReveal>
          <br data-id="element-46" data-mp="1potd4i6o6z48" />
          <TextReveal data-id="element-47" data-mp="1pob92zdrnglr">Questions</TextReveal>
        </h2>

        <ul className="mt-10 flex flex-col" data-id="element-48" data-mp="1ks2w9sn1jzhr">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="border-b border-[#D9D9D9]" data-id="element-49" data-mp="2dfozv0w9r44m" data-mpi={index}>
                <h3 data-id="element-50" data-mp="2ddmcypqexr44">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-51" data-mp="28gm5cadx0gaw">
                    <span className="text-base font-medium text-[#2D2D2D]" data-id="element-52" data-mp="s35fjtyhaar4">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-[#2D2D2D]" aria-hidden="true" data-id="element-53" data-mp="2zonotudm79dh" /> : <PlusIcon className="h-5 w-5 shrink-0 text-[#6F6F6F]" aria-hidden="true" data-id="element-54" data-mp="38oaghogjl0tc" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="3idu4f8j43kv2">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-56" data-mp="3ncnib22b9dvr">
                      <p className="max-w-[820px] pb-6 text-sm leading-6 text-[#595959]" data-id="element-57" data-mp="221exvjuuh843">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}